var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import axios from 'axios';
import dayjs from 'dayjs';
import config from '../services/config';
import NotificationService, { NotificationSeverity } from '../services/NotificationService';
import * as authActions from '../store/actions/auth';
import { store } from '../store/store';
var ClientOAuth2 = require('client-oauth2');
var oauthClient = new ClientOAuth2(config.auth);
var ApiService = /** @class */function () {
  function ApiService(url, type) {
    this.refreshing = false;
    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.delete = this.delete.bind(this);
    this.buildQuery = this.buildQuery.bind(this);
    this.buildUrl = this.buildUrl.bind(this);
    this.request = this.request.bind(this);
    this.url = url;
    this.headers = {};
    this.token = null;
    this.type = type;
  }
  ApiService.prototype.setToken = function (token) {
    this.token = token;
  };
  ApiService.prototype.get = function (url, opts) {
    return this.request('GET', url, opts || {});
  };
  ApiService.prototype.post = function (url, data, opts) {
    return this.request('POST', url, __assign(__assign({}, opts), {
      data: data
    }));
  };
  ApiService.prototype.put = function (url, data, opts) {
    return this.request('PUT', url, __assign(__assign({}, opts), {
      data: data
    }));
  };
  ApiService.prototype.delete = function (url, opts) {
    return this.request('DELETE', url, opts || {});
  };
  ApiService.prototype.addParam = function (key, value, url, query) {
    if (query == null) {
      query = '';
    }
    if (query.length > 0 || url.indexOf('?') > -1) {
      query += '&';
    }
    if (query.length === 0 && url.indexOf('?') === -1) {
      query += '?';
    }
    query += key + '=' + encodeURIComponent(value);
    return query;
  };
  ApiService.prototype.buildQuery = function (url, queryParams) {
    if (queryParams == null) {
      queryParams = {};
    }
    var query = '';
    for (var k in queryParams) {
      var v = queryParams[k];
      if (v == null || v === '') {
        continue;
      }
      // Convert dayjs dates into the format PHP expects
      if (v && v !== '' && dayjs.isDayjs(v)) {
        query = this.addParam(k, v.format(config.phpDateFormat), url, query);
      } else if (v.startDate != null) {
        query = this.addParam('startDate', v.startDate.format(config.phpDateFormat), url, query);
        query = this.addParam('endDate', v.endDate.format(config.phpDateFormat), url, query);
      } else if (Array.isArray(v)) {
        if (v.length === 0) {
          continue;
        }
        query = this.addParam(k, v.join(','), url, query);
      } else if (v != null && v !== '') {
        query = this.addParam(k, v, url, query);
      }
    }
    return query;
  };
  ApiService.prototype.buildUrl = function (resource, queryParams) {
    return this.url + resource + this.buildQuery(resource, queryParams);
  };
  ApiService.prototype.isTokenExpired = function () {
    var token = oauthClient.createToken(this.token.accessToken, this.token.refreshToken, this.token.tokenType, this.token.data);
    // Build in a 10min buffer where we will proactively refresh the token if it is close to expiring
    var expiresDate = new Date(this.token.expires);
    expiresDate.setMinutes(expiresDate.getMinutes() - 10);
    token.expiresIn(expiresDate);
    return token.expired();
  };
  ApiService.prototype.refreshToken = function () {
    var _this = this;
    return new Promise(function (resolve) {
      return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!this.refreshing) return [3 /*break*/, 2];
              return [4 /*yield*/, new Promise(function (resolve) {
                return setInterval(function () {
                  return !_this.refreshing ? resolve(_this.token) : null;
                }, 100);
              })];
            case 1:
              _a.sent();
              _a.label = 2;
            case 2:
              if (this.token == null) {
                return [2 /*return*/, resolve(null)];
              }
              if (!this.isTokenExpired()) {
                return [2 /*return*/, resolve(this.token)];
              }
              this.refreshing = true;
              store.dispatch(authActions.refreshToken(this.token)).then(function (token) {
                _this.refreshing = false;
                _this.token = token;
                resolve(token);
              });
              return [2 /*return*/];
          }
        });
      });
    });
  };
  ApiService.prototype.request = function (method, url, opts) {
    var _this = this;
    // We load this file prior to loading the config. Check if the url has changed and update accordingly
    if (this.type == 'site') {
      if (this.url != config.api.url) {
        this.url = config.api.url;
      }
    } else if (this.type == 'central') {
      if (this.url != config.centralApi.url) {
        this.url = config.centralApi.url;
      }
    }
    var queryParams = opts.params || {};
    return this.refreshToken().then(function (token) {
      var state = store.getState();
      var headers = Object.assign({}, _this.headers, {
        Authorization: token ? "Bearer ".concat(token.accessToken) : 'None',
        'Content-Type': opts.contentType !== false ? opts.contentType || 'application/json' : undefined
      });
      if (state.common.facility) {
        headers['X-Facility-ID'] = state.common.facility.id;
      }
      var api = axios.create({
        baseURL: _this.url
      });
      return api.request({
        url: _this.buildUrl(url, queryParams),
        method: method,
        headers: headers,
        data: opts.contentType !== false ? JSON.stringify(opts.data) : opts.data
      }).then(function (response) {
        return response.data;
      }).catch(function (err) {
        var _a, _b;
        if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) == 401) {
          store.dispatch(authActions.logout(true));
        }
        if (((_b = err.response) === null || _b === void 0 ? void 0 : _b.status) == 403) {
          NotificationService.show({
            message: 'Permission denied',
            severity: NotificationSeverity.ERROR
          });
        }
        return Promise.reject(err.response.data);
      });
    });
  };
  return ApiService;
}();
export default ApiService;